(() => {
  if (customElements.get('njt-parts-menu')) return;
  const vehicleKey = 'filter.p.m.organizer.car_models';
  const previewKeys = ['preview_theme_id', '_fd', 'pb'];
  class PartsMenu extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.trigger = this.querySelector('.njp-trigger');
      this.dialog = this.querySelector('.njp-dialog');
      this.parentList = this.querySelector('.njp-parents');
      this.trigger.addEventListener('click', () => this.open());
      this.querySelector('[data-njp-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => {
        this.trigger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('njp-modal-open');
      });
      this.dialog.addEventListener('click', event => {
        const rect = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
        const parent = event.target.closest('[data-njp-parent]');
        if (parent) this.showCategory(parent);
        if (event.target.closest('.njp-back')) this.reset(true);
        const link = event.target.closest('[data-njp-link]');
        if (link && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && !event.button) {
          const url = new URL(link.href);
          const catalog = document.querySelector('njt-suspension');
          const handle = url.pathname.split('/').filter(Boolean).pop();
          const suspensionHandles = ['suspension', 'suspension-lift-kit', 'spacer-leveling-lift-kit', 'shocks-1', 'coils-struts', 'body-lifts', 'control-arms-track-bars', 'steering-stablizer-tie-rod-drag-link', 'ball-joints', 'sway-bar-kits-bump-stops', 'leaf-springs-air-bags', 'lift-kit-components-accessories'];
          if (catalog && suspensionHandles.includes(handle) && typeof catalog.navigate === 'function') {
            event.preventDefault();
            this.dialog.close();
            catalog.navigate(url);
          }
        }
      });
      this.sync = () => this.update();
      this.resize = () => { if (this.dialog.open) this.position(); };
      document.addEventListener('njt:vehicle-state', this.sync);
      window.addEventListener('popstate', this.sync);
      window.addEventListener('resize', this.resize);
      const parents = [...this.querySelectorAll('[data-njp-parent]')];
      const rows = Math.ceil(parents.length / 2);
      this.dialog.style.setProperty('--njp-rows', rows);
      parents.forEach((button, index) => {
        button.style.setProperty('--njp-row', index % rows + 1);
        button.style.setProperty('--njp-column', index < rows ? 1 : 2);
        button.classList.toggle('njp-second-column', index >= rows);
      });
      this.update();
    }
    disconnectedCallback() {
      document.removeEventListener('njt:vehicle-state', this.sync);
      window.removeEventListener('popstate', this.sync);
      window.removeEventListener('resize', this.resize);
      if (this.dialog?.open) this.dialog.close();
      document.body.classList.remove('njp-modal-open');
    }
    update() {
      const current = new URL(location.href);
      const vehicle = current.searchParams.get(vehicleKey) || '';
      this.querySelector('[data-njp-vehicle-text]').textContent = [...document.querySelectorAll('#vehicle-identifiers option')].find(o => o.value === vehicle)?.textContent.trim() || vehicle || this.dataset.allVehicles;
      const photoOption = [...document.querySelectorAll('#vehicle-identifiers option')].find(o => o.value === vehicle);
      const photo = this.querySelector('[data-njp-vehicle-image]');
      const photoUrl = photoOption?.dataset.vehicleImage || '';
      if (photo) {
        photo.hidden = !vehicle || !photoUrl;
        if (photoUrl && vehicle) {
          if (photo.getAttribute('src') !== photoUrl) photo.src = photoUrl;
        } else photo.removeAttribute('src');
      }
      const pickup = /f[ -]?(?:150|250|350|450)|ram|silverado|sierra|tacoma|tundra|titan|frontier|ranger|colorado|canyon|avalanche|ridgeline|maverick/i.test(vehicle);
      this.querySelector('[data-njp-pickup]').hidden = !vehicle || !pickup || Boolean(photoUrl);
      this.querySelector('[data-njp-jeep]').hidden = !vehicle || pickup || Boolean(photoUrl);
      this.querySelectorAll('[data-njp-link]').forEach(link => {
        link.dataset.base ||= link.getAttribute('href');
        const target = new URL(link.dataset.base, location.origin);
        target.search = '';
        if (vehicle) target.searchParams.set(vehicleKey, vehicle);
        previewKeys.forEach(key => { if (current.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key)); });
        link.href = target.href;
        if (target.pathname === current.pathname) link.setAttribute('aria-current', 'page');
        else link.removeAttribute('aria-current');
      });
      this.querySelectorAll('[data-njp-parent]').forEach(button => {
        const panel = this.panel(button.dataset.njpParent);
        const active = new URL(button.dataset.parentPath, location.origin).pathname === current.pathname || Boolean(panel?.querySelector('[aria-current="page"]'));
        button.classList.toggle('njp-current', active);
      });
    }
    panel(key) {
      return [...this.querySelectorAll('[data-njp-sub]')].find(panel => panel.dataset.njpSub === key);
    }
    open(modal = true) {
      this.update();
      this.reset();
      if (modal) this.dialog.showModal(); else this.dialog.show();
      this.trigger.setAttribute('aria-expanded', 'true');
      if (modal) document.body.classList.add('njp-modal-open');
      this.position();
    }
    reset(focus = false) {
      const previous = this.querySelector('[data-njp-parent][aria-expanded="true"]');
      this.querySelectorAll('[data-njp-sub]').forEach(panel => panel.hidden = true);
      this.querySelectorAll('[data-njp-parent]').forEach(button => button.setAttribute('aria-expanded', 'false'));
      this.dialog.classList.remove('njp-has-sub');
      this.parentList.removeAttribute('inert');
      if (focus) previous?.focus({preventScroll:true});
      if (this.dialog.open) this.position();
    }
    showCategory(button) {
      this.reset();
      const panel = this.panel(button.dataset.njpParent);
      if (!panel) return;
      button.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      this.dialog.classList.add('njp-has-sub');
      this.position();
      this.querySelector('.njp-content').scrollTop = 0;
      panel.querySelector('h3').focus({preventScroll:true});
    }
    position() {
      const mobile = matchMedia('(max-width: 749px)').matches;
      this.parentList.toggleAttribute('inert', mobile && this.dialog.classList.contains('njp-has-sub'));
      if (mobile) {
        this.dialog.style.removeProperty('left');
        this.dialog.style.removeProperty('top');
        this.dialog.style.removeProperty('max-height');
        return;
      }
      const zoom = parseFloat(getComputedStyle(document.body).zoom) || 1;
      this.dialog.style.top = `${8 / zoom}px`;
      this.dialog.style.maxHeight = `${Math.max(180, (window.innerHeight - 16) / zoom)}px`;
      const width = this.dialog.getBoundingClientRect().width;
      this.dialog.style.left = `${Math.max(8, (window.innerWidth - width) / 2) / zoom}px`;

    }
  }
  customElements.define('njt-parts-menu', PartsMenu);
})();
